import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决跳转到当前路由的冲突报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 路由配置
const routes = [

  {
    path: '/',
    name: 'Main',
    component: () => import(/* webpackChunkName: "Main" */ '../views/Main'),
    children: [
      {
        path: '',
        redirect: '/index'
      },
      {
        path: '/index',
        component: () => import(/* webpackChunkName: "Home" */ '../views/components/Home')
      },
      {
        path: '/qyxx',
        component: () => import(/* webpackChunkName: "EnterpriseInfoIndex" */ '../views/components/EnterpriseInfo/Index'),
        children: [
          {
            path: 'qyjj',
            component: () => import(/* webpackChunkName: "EnterpriseIntro" */ '../views/components/displayBlocks/EnterpriseIntroBlock')
          }, {
            path: 'bszn',
            component: () => import(/* webpackChunkName: "DepartmentsIntro" */ '../views/components/displayBlocks/DepartmentsIntroBlock')
          }, {
            path: 'dsj',
            component: () => import(/* webpackChunkName: "BigEvents" */ '../views/components/displayBlocks/BigEventBlock')
          }]
      },
      {
        path: '*',
        component: () => import(/* webpackChunkName: "Docs" */ '../views/components/Docs')
      }
    ]

  }

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
